const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"HvwqPPU3P9nv7fFMVHEJP"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-app@trilogy-health-ns"]={id:"HvwqPPU3P9nv7fFMVHEJP"};
      